module.exports = __webpack_public_path__ + "img/gac_flaffytokens.2c4b974.png";